
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class AiBuilderStep extends Vue {
  @Prop({ type: Number, default: 0 }) current!: number; //当前步骤
  @Prop({
    type: Array,
    default: () => ["维度选择", "题目选择", "分数配置", "测评配置", "面试设置"]
  })
  stepList!: string[];

  mounted() {
    //todo
  }
}
